/**
 * 搜索结果展示配置常量
 * 集中管理所有展示相关的配置
 */

export const SEARCH_RESULT_CONFIG = {
  // 图片画廊配置
  imageGallery: {
    maxDisplayImages: 12, // 最多显示图片数
    gridColumns: 3, // 网格列数
    gridGap: 'gap-1.5', // 网格间距
  },

  // 搜索来源配置
  sources: {
    maxHeight: 360, // 来源列表最大高度
    showCount: 5, // 默认显示建议数量
  },

  // Tab 配置
  tabs: {
    searchTab: 'search',
    savedTab: 'saved',
  },

  // 样式配置
  styles: {
    // 颜色
    colors: {
      searchIcon: 'text-blue-400',
      ragIcon: 'text-purple-400',
      errorIcon: 'text-red-400',
      savedIcon: 'text-purple-400/70',
      infoIcon: 'text-green-400/70',
      emeraldIcon: 'text-emerald-300',
      amberIcon: 'text-amber-300',
    },

    // 尺寸
    sizes: {
      textXs: 'text-[11px]',
      textSm: 'text-[10px]',
      iconSm: 10,
      iconMd: 12,
      iconLg: 14,
      iconXl: 16,
    },

    // 间距
    spacing: {
      xs: 'gap-0.5',
      sm: 'gap-1',
      md: 'gap-2',
    },
  },

  // 动画配置
  animation: {
    transition: 'transition-colors',
    hoverBg: 'hover:bg-white/[0.04]',
  },

  // URL 配置
  url: {
    placeholderImage: 'https://via.placeholder.com/300x300/1f2937/6b7280?text=图片加载失败',
  },
} as const;

export const SEARCH_TYPE_LABELS = {
  general: '网页',
  image: '图片',
  video: '视频',
  news: '新闻',
  rag: 'RAG 增强',
} as const;

export const ERROR_MESSAGES = {
  searchUnavailable: '搜索服务暂时不可用',
  noResults: '未找到相关结果',
  retrySuggestion: '请稍后重试，或尝试简化搜索关键词',
  suggestion: {
    shortQuery: '尝试更简短的关键词',
    checkSpelling: '检查拼写',
  },
} as const;

export const ACTION_LABELS = {
  expand: '展开摘要',
  collapse: '收起',
  viewSource: '搜索来源',
} as const;
